export const CalcPeriodKey = ({ bidCategory }) =>
  `${bidCategory.toLowerCase()}Periods`;
